import Vue from "vue";
import Vuetify from "vuetify/lib";
import CustomIcons from "../utiles/customIcons";
import themes from "./themes";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  icons: {
    values: CustomIcons
  },
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes: themes
  }
});
